var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('a-tabs', {
    attrs: {
      "data-permission": "transport_order_settings_tab",
      "id": "transport_order_settings_tab",
      "data-sign": "transport_order_settings_tab",
      "size": "small",
      "animated": false
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, _vm._l(_vm.tabList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "data-sign": item.dataSign,
        "tab": item.text
      }
    });
  }), 1), _c(_vm.activeTab, {
    tag: "component"
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };